import React, { useState } from "react";

const NewGP = ({ onSubmit, onCancel }) => {
    // ref
    const [model, setModel] = useState({});

    return (
        <form
            method="POST"
            onSubmit={event => {
                event.preventDefault();
                onSubmit(model);
                // clear
                setModel({});
            }}
        >
            <div className="form-group">
                <label htmlFor="name-id">Name</label>
                <input
                    type="text"
                    className="form-control input-height"
                    id="name-id"
                    required
                    onChange={({ target }) => setModel({ ...model, name: target.value })}
                    aria-describedby="name-id"
                    placeholder="enter name"
                />
            </div>
            <div className="form-group">
                <label htmlFor="email-id">Email</label>
                <input
                    type="email"
                    className="form-control input-height"
                    id="email-id"
                    required
                    onChange={({ target }) => setModel({ ...model, email: target.value })}
                    aria-describedby="email-id"
                    placeholder="enter email"
                />
            </div>
            <div className="form-group">
                <label htmlFor="email-id">Phone Number</label>
                <input
                    type="text"
                    className="form-control input-height"
                    id="phone-id"
                    required
                    onChange={({ target }) => setModel({ ...model, mobile: target.value })}
                    aria-describedby="phone-id"
                    placeholder="enter phone number"
                />
            </div>
            <div className="form-group">
                <label htmlFor="post-id">Post Code</label>
                <input
                    type="text"
                    className="form-control input-height"
                    id="post-id"
                    required
                    onChange={({ target }) => setModel({ ...model, postCode: target.value })}
                    aria-describedby="post-id"
                    placeholder="enter post code"
                />
            </div>

            <div className="form-group">
                <label htmlFor="address-id">Contact Address</label>
                <textarea
                    name="address-id"
                    id="address-id"
                    onChange={({ target }) => setModel({ ...model, address: target.value })}
                    className="form-control form-control-textarea"
                    required
                    rows="2"
                    placeholder="enter contact address"
                ></textarea>
            </div>

            <div className="text-center">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Submit <i className="material-icons">arrow_right_alt</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
};

export default NewGP;
